<template>
  <div class="Renewal">
    <div class="topbar">
      <i @click="goHome"></i>

      <div class="userInfo">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>

        <div class="settingBtn" @click.stop="setting()">
          {{ name ? name : names }}
          <em class="iconfont icon-een"></em>
          <ul v-show="settingBoxVis" class="chooseLangUl chooseLangUls">
            <li @click="toMyAccount">{{ $t("myHome") }}</li>
            <li @click="race">{{ $t("myPageTitle") }}</li>
            <li @click="logOut">{{ $t("setting_2") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="mainBox" @click="clickBox" id="mainBox">
      <div class="signInBox">
        <div class="forgetPsd1">{{ $t("pay_txt1") }}</div>
      </div>

      <div class="container">
        <div class="explanation">
          <div class="title" v-if="switchType == '0'">
            {{ $t("pay_txt2") }}
          </div>
          <div class="title" v-if="switchType == '1'">
            {{ $t("pay_txt2_1") }}
          </div>

          <div class="explanationMsgs">
            <div
              class="btext"
              v-if="switchType == '0'"
              v-html="$t('langTitle')"
            ></div>
            <div
              class="text"
              v-if="switchType == '0'"
              v-html="$t('langTitle_1')"
            ></div>

            <div
              class="btext"
              v-if="switchType == '1'"
              v-html="$t('langTitle2')"
            ></div>
            <div
              class="text"
              v-if="switchType == '1'"
              v-html="$t('langTitle2_1')"
            ></div>
          </div>
        </div>

        <div class="space"></div>

        <div class="pay">

          <section 
            v-if="$i18n.locale != 'he'"
            class="pay-box"
            :class='{active: switchMode == "0"}'
            @click="switchModeHandle('0')">
            <div class="pic">
              <img :src="img2Url" width="100%" />
            </div>

            <div class="msg">
              <span class="bg">{{ $t("pay_text10_1") }}</span>
              <span class="bg">{{ $t("pay_text10_2") }}</span>
              <span class="sm">{{ $t("pay_text10_3") }}</span>
              <span class="sm">{{ $t("pay_text10_4") }}</span>
            </div>
          </section>
          <section
            v-if="$i18n.locale != 'he'"
            class="pay-box"
            :class='{active: switchMode == "1"}'
            @click="switchModeHandle('1')"
          >
            <div class="msg">
              <span class="bg">{{ $t("pay_text4_0") }}</span>
              <span class="bg">{{ $t("pay_text4_1") }}</span>
              <span class="sm">{{ $t("pay_text4_2") }}</span>
              <span class="sm">{{ $t("pay_text4_3") }}</span>
              <span class="sm">{{ $t("pay_text4_4") }}</span>
            </div>
            <div class="pic">
              <img :src="img2Url" width="150px" height="150px" />
            </div>
            <!-- 需要替换成特派员二维码 -->
            <!-- src="~@/assets/images/pay-2-pic.png" -->
          </section>

          

          <div class="useCodeBtn" @click="usingCode = true">
            <b>{{ $t("redeemCode_useBtn") }}</b>
          </div>

          <div class="bgiOver" v-show="usingCode">
            <!-- 兑换码弹窗 -->
            <div class="codeUse">
              <div
                class="codeUse-closeBtn"
                @click="(usingCode = false), closeCodeUsing()"
              ></div>
              <div class="codeUse-title">
                <span>{{ $t("redeemCode_dialog_title") }}</span>
              </div>
              <div class="codeUse-input">
                <input
                  v-model="codeUsingInput"
                  :placeholder="$t('redeemCode_dialog_input_hint')"
                />
              </div>
              <div class="codeUse-info">
                <span>{{ $t("redeemCode_dialog_info") }}</span>
              </div>
              <div class="codeUse-confirmBtn">
                <span @click="submitCode(codeUsingInput)">
                  {{ $t("redeemCode_usingBtn") }}
                </span>
              </div>
            </div>
            <!-- 兑换码弹窗 -->
          </div>
        </div>
      </div>
    </div>

    <div class="bgiOvers" v-show="chatShow">
      <div class="over over1">
        <div class="timeout03">{{ time }}s后自动进入首页</div>
        <div class="timeout04" @click="goHome()"></div>
      </div>
    </div>

    <LeapPopup
      v-show="maskBox"
      @onOK="logOut"
      :title="$t('timeout01')"
      :content="$t('timeout02')"
      :cancelButtonTxt="$t('timeout04')"
      :okButtonTxt="$t('timeout03')"
      :isConfirm="false"
    ></LeapPopup>
  </div>
</template>

<script>
import Axios from "axios";
import store from "../store";
import { mapGetters } from "vuex";
import MediaUtils from "@/utils/MediaUtils";
import LeapPopup from "./LeapPopup";
import I18nUtils from "@/utils/i18nUtils";

Axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      codeUsingInput: "",
      usingCode: false,
      changeLangBox: false,
      settingBoxVis: false,
      langList: I18nUtils.langList,
      myInterval: null,

      imgUrl: "",
      img2Url: "",

      config: {
        logo: MediaUtils.getStaticDomain() + "icode.png",
      },
      imgShow: true,
      time: 5,
      chatShow: false,
      names: "",
      // 0 个人 | 1 机构/学校
      switchType: "0",
      switchMode: "0",

      event51Show: false,
      paySelect: "r",
      prizeCutId: 0,
      interTwinedFate: "29.8",
    };
  },

  components: {
    LeapPopup,
  },

  computed: {
    ...mapGetters(["maskBox", "name"]),
    lan() {
      return this.$i18n.locale;
    },
  },

  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },
    // 获取该账号当前地区的二维码
    async getImg2Url() {
      try {
        await this.$http.getAxios.get("/user/getManagerUrl").then((res) => {
          const _res = res.data;
          if (_res.code == 0) {
            this.img2Url = _res.data.url;
          } else {
            console.log("未查找到相关地区所对应的图片");
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * 获取支付二维码
     */
    async getPayQrCode(val) {
      try {
        let res = await this.$http.getAxios("/wx/getPayQrCode", {
          method: "post",
          data: { productId: val || 1 },
        });
        if (res.data.code == 0) {
          this.imgUrl = res.data.msg;
          this.imgShow = false;
        } else if (res.data.code == 1) {
          clearInterval(this.myInterval);
        } else {
          clearInterval(this.myInterval);
        }
        // var res = window.URL.createObjectURL(res.data);
      } catch (err) {
        console.log(err);
      }
    },

    switchModeHandle(val) {
      this.switchType = val;
      this.switchMode = val;
      // if (val == "true") {
      //   // this.switchMode = true;
      //   this.switchType = "0";
      // } else {
      //   // this.switchMode = false;
      //   this.switchType = "1";
      // }
    },

    getOrder() {
      this.$http
        .getAxios("/wx/getOrderStatus", {
          method: "post",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.chatShow = true;
            clearInterval(this.myInterval);
            this.vCodeTimer();
          }
        });
    },

    initList() {
      this.myInterval = window.setInterval(() => {
        setTimeout(() => {
          this.getOrder(); //调用接口的方法
        }, 1);
      }, 2000);
    },
    vCodeTimer() {
      var count = 1,
        sum = 5;
      var i = setInterval(() => {
        if (count > 5) {
          clearInterval(i);
          this.chatShow = false;
          this.$router.push({ path: "/index" });
        } else {
          this.time = parseInt(sum - count);
        }
        count++;
      }, 1000);
    },

    // 用户优惠
    userPrizeCutHandle() {
      try {
        this.$http.getAxios.get("wx/getProductId").then((res) => {
          var _res = res.data;

          switch (_res.code) {
            case 0: {
              this.prizeCutId = _res.data.productId;
              this.getPayQrCode(_res.data.productId);
              break;
            }

            default: {
              if (this.$i18n.locale == "zh") {
                this.$confirm(`接口出错，请联系ICode工作人员`, "错误", {
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  center: true,
                  showCancelButton: false,
                  confirmButtonText: "好的",
                });
              } else {
                this.$confirm(
                  `Interface error, please contact ICode staff`,
                  "Error",
                  {
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                  }
                );
              }
              break;
            }
          }
        });
      } catch (error) {
        this.$notify.error({
          title: "错误代码：LK-42",
          message: "请联系ICode工作人员解决您的问题",
        });
      }
    },

    /**
     * 兑换码
     */
    submitCode(val) {
      if (val.length === 16) {
        // 转换大写
        let _val = val.toUpperCase();

        try {
          this.$http.getAxios
            .get("/ticket/checkTicket", {
              params: {
                ticketNo: _val,
              },
            })
            .then((res) => {
              var _res = res.data;
              // console.log(_res);

              switch (_res.code) {
                case 114: {
                  // 兑换码已被使用
                  this.$confirm(
                    this.$t("redeemCode_114_1"),
                    this.$t("redeemCode_114_2"),
                    {
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      center: true,
                      showCancelButton: false,
                      confirmButtonText: this.$t("redeemCode_confirm"),
                    }
                  );
                  break;
                }

                case 115: {
                  var _time = this.format(_res.data.timestamp * 1000);

                  // 兑换码过期
                  this.$confirm(
                    this.$t("redeemCode_115_1") +
                      _time +
                      this.$t("redeemCode_115_2"),
                    this.$t("redeemCode_115_3"),
                    // `您输入的兑换码已于<b>${_time}</b>过期<br/>若有疑问，请联系ICode工作人员`,
                    // "兑换码已过期",
                    {
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      center: true,
                      showCancelButton: false,
                      confirmButtonText: this.$t("redeemCode_confirm"),
                    }
                  );
                  break;
                }

                case 116: {
                  // 兑换码错误（仅仅格式正确）
                  this.$confirm(
                    this.$t("redeemCode_116_1"),
                    this.$t("redeemCode_116_2"),
                    {
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      center: true,
                      showCancelButton: false,
                      confirmButtonText: this.$t("redeemCode_confirm"),
                    }
                  );
                  break;
                }

                case 117: {
                  var _time = this.format(_res.data.timestamp * 1000);

                  // 一年以上不能兑换
                  this.$confirm(
                    this.$t("redeemCode_117_1") +
                      _time +
                      this.$t("redeemCode_117_2"),
                    this.$t("redeemCode_117_3"),
                    {
                      dangerouslyUseHTMLString: true,
                      type: "warning",
                      center: true,
                      showCancelButton: false,
                      confirmButtonText: this.$t("redeemCode_confirm"),
                    }
                  );
                  break;
                }

                case 0: {
                  // 兑换成功 code=0 会多返回一个dataCount
                  var _dateCount = _res.data.dateCount;
                  var _time = this.format(_res.data.timestamp * 1000);

                  this.$confirm(
                    this.$t("redeemCode_0_1") +
                      _dateCount +
                      this.$t("redeemCode_0_2") +
                      _time +
                      this.$t("redeemCode_0_3"),
                    this.$t("redeemCode_0_4"),
                    {
                      dangerouslyUseHTMLString: true,
                      type: "warning",
                      center: true,
                      confirmButtonText: this.$t("redeemCode_0_checkBtn1"),
                      cancelButtonText: this.$t("redeemCode_0_checkBtn2"),
                      // cancelButtonText: this.$t("txt123"),
                    }
                  )
                    .then(() => {
                      this.useTicket(_val);
                    })
                    .catch((action) => {
                      if (action === "cancel" || "close") {
                        if (this.$i18n.locale == "zh") {
                          this.$message({
                            type: "info",
                            message: "暂未兑换此兑换码",
                          });
                        } else {
                          this.$message({
                            type: "info",
                            message:
                              "This redemption code has not yet been redeemed",
                          });
                        }
                      }
                    });

                  break;
                }

                default: {
                  if (this.$i18n.locale == "zh") {
                    this.$confirm(`接口出错，请联系ICode工作人员`, "错误", {
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      center: true,
                      showCancelButton: false,
                      confirmButtonText: "好的",
                    });
                  } else {
                    this.$confirm(
                      `Interface error, please contact ICode staff`,
                      "Error",
                      {
                        dangerouslyUseHTMLString: true,
                        type: "error",
                        center: true,
                        showCancelButton: false,
                        confirmButtonText: "OK",
                      }
                    );
                  }
                  break;
                }
              }
            });
        } catch (err) {
          this.$notify.error({
            title: "错误代码：LK-1",
            message: "请联系ICode工作人员解决您的问题",
          });
        }
      } else {
        // 输入错误
        if (this.$i18n.locale == "zh") {
          this.$message({
            message: "兑换失败！请检查兑换码输入是否正确无误。",
            center: true,
            type: "error",
          });
        } else {
          this.$message({
            message:
              "The redeem code you entered is wrong！please check and enter again.",
            center: true,
            type: "error",
          });
        }
      }
    },

    /**
     * checkTicket 和 useTicket 的两接口的返回值是一样的
     * 二次验证，防止攻击（当时后端的原话）
     */
    useTicket(val) {
      try {
        this.$http.getAxios
          .get("ticket/useTicket", {
            params: {
              ticketNo: val,
            },
          })
          .then((res) => {
            var _res = res.data;

            switch (_res.code) {
              case 114: {
                // 兑换码已被使用
                this.$confirm(
                  this.$t("redeemCode_114_1"),
                  this.$t("redeemCode_114_2"),
                  {
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t("redeemCode_confirm"),
                  }
                );
                break;
              }

              case 115: {
                var _time = this.format(_res.data.timestamp * 1000);

                // 兑换码过期
                this.$confirm(
                  this.$t("redeemCode_115_1") +
                    _time +
                    this.$t("redeemCode_115_2"),
                  this.$t("redeemCode_115_3"),
                  // `您输入的兑换码已于<b>${_time}</b>过期<br/>若有疑问，请联系ICode工作人员`,
                  // "兑换码已过期",
                  {
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t("redeemCode_confirm"),
                  }
                );
                break;
              }

              case 116: {
                // 兑换码错误（仅仅格式正确）
                this.$confirm(
                  this.$t("redeemCode_116_1"),
                  this.$t("redeemCode_116_2"),
                  {
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t("redeemCode_confirm"),
                  }
                );
                break;
              }

              case 117: {
                var _time = this.format(_res.data.timestamp * 1000);

                // 一年以上不能兑换
                this.$confirm(
                  this.$t("redeemCode_117_1") +
                    _time +
                    this.$t("redeemCode_117_2"),
                  this.$t("redeemCode_117_3"),
                  {
                    dangerouslyUseHTMLString: true,
                    type: "warning",
                    center: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t("redeemCode_confirm"),
                  }
                );
                break;
              }

              case 0: {
                var _time = this.format(_res.data.timestamp * 1000);

                // 兑换成功
                this.$confirm(
                  this.$t("redeemCode_0_5") +
                    _time +
                    this.$t("redeemCode_0_6"),
                  this.$t("redeemCode_0_7"),
                  {
                    dangerouslyUseHTMLString: true,
                    type: "success",
                    center: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t("redeemCode_confirm"),
                  }
                );

                break;
              }

              default: {
                if (this.$i18n.locale == "zh") {
                  this.$confirm(`接口出错，请联系ICode工作人员`, "错误", {
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    showCancelButton: false,
                    confirmButtonText: "好的",
                  });
                } else {
                  this.$confirm(
                    `Interface error, please contact ICode staff`,
                    "Error",
                    {
                      dangerouslyUseHTMLString: true,
                      type: "error",
                      center: true,
                      showCancelButton: false,
                      confirmButtonText: "OK",
                    }
                  );
                }
                break;
              }
            }
          });
      } catch (error) {
        this.$notify.error({
          title: "错误代码：LK-2",
          message: "请联系ICode工作人员解决您的问题",
        });
      }
    },

    closeCodeUsing() {
      this.codeUsingInput = "";
    },

    goHome() {
      this.$router.push({ path: "/index" });
    },

    clickBox() {
      this.changeLangBox = false;
      this.settingBoxVis = false;
    },

    setting() {
      this.settingBoxVis = !this.settingBoxVis;
      this.changeLangBox = false;
    },

    race() {
      this.$router.push({ path: "/myPage" });
    },

    toMyAccount() {
      this.$router.push({ path: "/index" });
    },

    logOut() {
      this.$http
        .getAxios("/user/logout", {
          method: "post",
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            store.commit("toggleMaskState", false);
            this.$router.push({ path: "/" });
          }
        });
    },

    ideResize() {
      // let mainBox = document.getElementById("mainBox");
      // console.log(mainBox);
      // let w = document.documentElement.offsetWidth || document.body.offsetWidth;
      // if(w < 1220)
      // mainBox.style.transform = "scale(.6)";
      // mainBox.style.position = "absolute";
      // mainBox.style.top = "-130px";
      // mainBox.style.left = "-220px";
    },

    cancel() {
      store.commit("toggleMaskState", false);
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
      this.settingBoxVis = false;
    },

    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    format(t) {
      //t是整数，否则要parseInt转换
      var time = new Date(t);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var hours = time.getHours();
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();

      return (
        y +
        "-" +
        this.add0(m) +
        "-" +
        this.add0(d) +
        " " +
        this.add0(hours) +
        ":" +
        this.add0(minutes) +
        ":" +
        this.add0(seconds)
      );
    },
  },

  mounted() {
    if (MediaUtils.isMobileBrowser()) {
      let mainBox = document.getElementById("mainBox");
      mainBox.style.transform = "scale(.6)";
      mainBox.style.position = "absolute";
      mainBox.style.top = "0px";
      mainBox.style.left = "-250px";
    }

    this.names = localStorage.getItem("names") || "";
    // 默认支付，目前融合优惠机制
    // this.getPayQrCode(1);
    // this.userPrizeCutHandle();

    // this.initList();
    I18nUtils.initLanguage(this);

    this.getImg2Url();
  },

  destroyed() {
    clearInterval(this.myInterval);
  },
};
</script>

<style lang="scss">
.Renewal {
  .topbar {
    width: 100%;
    height: 60px;
    color: #aaf9fe;
    background: #122346;

    i {
      position: absolute;
      top: 8px;
      left: 40px;
      width: 172px;
      height: 46px;
      cursor: pointer;
      z-index: 9999;
      background: url("~@/assets/images/bigIcon.png") no-repeat center;
    }

    .userInfo {
      height: 60px;
      position: absolute;
      top: 0;
      right: 20px;
      z-index: 323;
      .changeLangBtn {
        cursor: pointer;
        float: right;
        font-weight: normal;
        font-size: 18px;
        line-height: 60px;
        padding-right: 20px;
      }
    }
  }

  .mainBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 60px);

    .signInBox {
      margin-top: 5vh;
      margin-bottom: 5vh;

      .forgetPsd1 {
        margin: 0 auto 3%;
        width: 453px;
        height: 58px;
        line-height: 58px;
        background: url("~@/assets/images/title.png") no-repeat center / contain;
        font-size: 40px;
        font-weight: bold;
        color: #0ff;
        text-align: center;
      }
    }

    .container {
      width: 1240px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .explanation {
      float: left;
      width: 65%;
      height: 566px;
      background: url("~@/assets/images/wechat_ins.png") center / cover
        no-repeat;

      .title {
        width: 100%;
        height: 60px;
        line-height: 60px;
        margin: 62px auto 0;
        text-align: center;
        font-size: 28px;
        color: #00ffff;
      }

      .explanationMsgs {
        box-sizing: border-box;
        width: 93%;
        height: 380px;
        line-height: 28px;
        margin: 20px auto 0;
        padding: 10px;
        overflow: auto;
        overflow-x: hidden;
        color: #fff;

        .btext {
          font-weight: bold;
          font-size: 18px;
          letter-spacing: 2px;
        }

        .text {
          font-size: 16px;
        }
      }
    }

    .space {
      float: left;
      width: 2%;
      height: 566px;
    }

    .pay {
      float: left;
      width: 33%;
      height: 566px;

      &-box {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        height: 201px;
        margin: 20px 0;
        background: url("~@/assets/images/pay-1.png") center / contain no-repeat;
        cursor: pointer;

        .msg {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 90%;
          color: #fff;

          span {
            margin: 3px 0;
          }

          .bg {
            font-weight: bold;
            font-size: 18px;
            letter-spacing: 1px;
          }
          .sm {
            font-size: 14px;
          }
        }

        .pic {
          width: 150px;
          height: 150px;
          box-sizing: border-box;
        }

        .pic51 {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 150px;
          height: 140px;
          color: #003950;
          font: 24px bold;
          background: url("~@/assets/images/event/event51/clickbtn.png") center /
            contain no-repeat;
        }
      }

      .active {
        background: url("~@/assets/images/pay-2.png") center / contain no-repeat;
      }

      .useCodeBtn {
        width: 309px;
        height: 73px;
        line-height: 70px;
        margin: 30px auto;
        text-align: center;
        color: #00ffff;
        background: url("~@/assets/images/useCodeBtn.png") center / contain
          no-repeat;
        cursor: pointer;

        b {
          color: #fff;
          font-size: 30px;
          font-weight: 700;
          text-shadow: #0ff 2px 2px;
          opacity: 0.7;
          transition: opacity 0.3s ease;

          &:hover {
            opacity: 1;
          }
        }
      }

      .codeUse {
        position: relative;
        width: 799px;
        height: 396px;
        margin: 0 auto;
        margin-top: 10%;
        background: url("~@/assets/images/useCodeBack.png") no-repeat 50%;
        background-size: cover;

        &-title {
          text-align: center;
          padding: 50px 0 43px;

          span {
            color: #fff;
            font-weight: bolder;
            font-size: 30px;
          }
        }

        &-info {
          text-align: center;
          padding: 5px 50px;
          margin-bottom: 1em;
          span {
            color: #fff;
            font-weight: bolder;
            font-size: 20px;
          }
        }

        &-closeBtn {
          position: absolute;
          opacity: 0.8;
          right: 50px;
          top: 30px;
          width: 42px;
          height: 42px;
          background: url("~@/assets/images/closebtn.png") no-repeat 50%;
          background-size: cover;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
        }

        &-input {
          text-align: center;
          margin-bottom: 2em;

          > input {
            width: 540px;
            border: 0;
            height: 55px;
            text-align: center;
          }
        }

        &-confirmBtn {
          height: 66px;
          line-height: 66px;
          text-align: center;
          background-image: url("~@/assets/images/confirmbtn.png");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          cursor: pointer;

          span {
            padding: 13px 90px;
            color: #fff;
            text-shadow: #0ff 2px 2px;
            font-size: 32px;
            font-weight: 700;

            opacity: 0.7;
            transition: opacity 0.4s ease;

            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  .event51 {
    display: flex;
    align-items: center;
    justify-content: center;

    .container {
      position: relative;
      width: 986px;
      height: 732px;
      background: url("~@/assets/images/event/event51/bg.png") center / contain
        no-repeat;

      .closebtn {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 55px;
        height: 55px;
        background: url("~@/assets/images/event/event51/closebtn.png") center /
          contain no-repeat;
        cursor: pointer;
      }

      &-box {
        position: absolute;
        top: 70px;
        left: 110px;
        width: 750px;
        height: 600px;
        text-align: center;
        color: #fff;
        h3 {
          font-size: 32px;
        }

        .pDesc {
          line-height: 24px;
          font-size: 20px;
          padding: 20px 42px;
        }

        .detailBox {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 440px;

          .switchBtn {
            width: 375px;

            .detail {
              box-sizing: border-box;
              width: 100%;
              height: 140px;
              margin: 5px 0;
              border: 1px solid #0e9eca;
              cursor: pointer;
              border-radius: 5px;
              transition: 0.3s ease all;

              &-Title {
                font-weight: bold;
                font-size: 28px;
                margin: 28px 20px;
              }
              &-desc {
                font-size: 20px;
              }
            }

            .active {
              background: #0e9eca;
              color: #fff;
              border: 1px solid #fff;
            }
          }

          .paybox {
            box-sizing: border-box;
            width: 370px;
            height: 430px;
            border: 1px solid #0e9eca;
            margin-left: 20px;
            padding: 10px;
            border-radius: 5px;

            img {
              margin: 40px;
              width: 220px;
              height: 220px;
            }

            p {
              font-size: 24px;
              margin-bottom: 10px;
              font-weight: bold;
            }
          }
        }
      }
    }

    .el-dialog {
      margin: 0 !important;
      box-shadow: unset;
      background: transparent;

      &__header {
        padding: 0;
      }

      &__body {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 85vh;
        color: unset;
        padding: unset;
      }
    }
  }

  .chooseLangUl {
    position: absolute;
    z-index: 111;
    li {
      height: 40px;
      cursor: pointer;
    }
  }

  .settingBtn {
    float: right;
    position: relative;
    min-width: 150px;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    margin-right: 20px;
    text-align: center;
    cursor: pointer;
  }

  .chooseLangUls {
    width: 100%;
    background: #0c355c;
    padding: 0 5px 10px 5px;
    border-radius: 5px;
  }

  .bgiOvers {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    .over {
      width: 750px;
      height: 400px;
      position: absolute;
      top: 20%;
      background: url("~@/assets/images/chatOk.png") no-repeat 1px 2px;
      left: 50%;
      transform: translateX(-50%) scale(0.9);
      z-index: 2001;
      border-radius: 20px;
      .timeout03 {
        width: 188px;
        height: 35px;
        position: absolute;
        top: 259px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        line-height: 35px;
        color: #fff;
        font-size: 22px;
      }
      .timeout04 {
        width: 188px;
        height: 35px;
        position: absolute;
        top: 314px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
      }
    }
  }

  /deep/ .el-loading-mask {
    z-index: 1;
  }

  .over {
    width: 725px;
    height: 467px;
    position: absolute;
    top: 20%;
    background: url("~@/assets/images/PopUp_bg.png") no-repeat 1px 2px;
    left: 50%;
    transform: translateX(-50%);
  }

  .over1 {
    width: 564px;
    height: 458px;
  }

  .bgiOver {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;
  }

  .timeout03 {
    width: 100px;
    height: 40px;
    position: absolute;
    top: 354px;
    left: 69px;
    text-align: center;
    line-height: 40px;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    font-weight: 700;
  }

  .timeout04 {
    width: 100px;
    height: 40px;
    position: absolute;
    top: 354px;
    left: 400px;
    text-align: center;
    line-height: 40px;
    color: #fff;
    font-size: 23px;
    cursor: pointer;
    font-weight: 700;
  }

  input:-webkit-autofill {
    box-shadow: 0 0 0 1000px white inset;
    -webkit-box-shadow: 0 0 0 1000px white inset;
  }
}

@media (max-width: 1200px) {
  .Renewal {
    .mainBox {
      transform: scale(0.9);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wechat.vue